// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3389":"66c83c75fa36239b","3944":"a5cc06bcbc1ea633","4702":"1775370d6ddc6591","7483":"d955ff79c774ddf6"}[chunkId] + ".js";
};